import React from "react";

import { useAppSelector } from "store";
import {
    chooseAllChainStatus,
    deselectAllChainStatus,
    selectChainStatus,
    toggleChainStatusIsSelected
} from "modules/customer/insights/portfolioNew/areaHealthNew/areaHealthNewSlice";
import MultiSelectFilter from "components/filters/MultiSelectFilter";

const ChainStatusFilter: React.FC = () => {
    const chainStatuses = useAppSelector(selectChainStatus);
    return (
        <MultiSelectFilter
            title="Chain status"
            items={chainStatuses}
            chooseAllItems={chooseAllChainStatus}
            deselectAllItems={deselectAllChainStatus}
            toggleItemIsSelected={toggleChainStatusIsSelected}
        />
    );
};

export default ChainStatusFilter;
